import styled from "styled-components";

interface IPageOption {
  isSelected: boolean;
}

export const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 250px);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const Content = styled.div`
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  padding: 32px 0 48px 0;
  flex: 1;

  @media (max-width: 1280px) {
    padding: 32px 16px 48px 16px;
  }
`;

export const ErrorMessageContainer = styled.div`
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  padding: 40px 16px;
  flex: 1;

  h2 {
    color: #666666;
    font-size: 24px;
    font-weight: 500;
    text-align: center;
  }
`;

export const PropertiesContainer = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;

  @media (max-width: 767px) {
    padding: 16px;
    overflow-x: auto;
  }
`;

export const InitialContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;

  h3 {
    font-size: 24px;
    font-weight: 600;
    color: #333333;
  }

  @media (max-width: 767px) {
    h3 {
      font-size: 20px;
    }
  }
`;

export const PropertiesTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 24px;

  thead tr {
    background: #f8f8f8;
  }

  th,
  td {
    padding: 14px 12px;
    text-align: left;
    border-bottom: 1px solid #eeeeee;
    font-size: 14px;
    color: #555555;
    vertical-align: middle;
  }

  th {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
  }

  .th-code {
    width: 90px;
    min-width: 90px;
  }

  tbody tr:hover {
    background: #fafafa;
  }

  @media (max-width: 767px) {
    min-width: 900px;
  }
`;

export const TableButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  button,
  svg {
    cursor: pointer;
  }

  button {
    border: 0;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  svg {
    transition: transform 0.2s;
  }

  svg:hover {
    transform: scale(1.08);
  }
`;

export const PagesContainer = styled.div`
  width: 100%;
  margin-top: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
`;

const BasePageOption = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #dddddd;
  background: #ffffff;

  display: flex;
  align-items: center;
  justify-content: center;

  a,
  p,
  svg {
    color: #666666;
    font-size: 14px;
    font-weight: 500;
  }

  a {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  svg {
    cursor: pointer;
  }
`;

export const PageOptionPrevious = styled(BasePageOption)``;

export const PageOptionLatter = styled(BasePageOption)``;

export const PageOption = styled(BasePageOption)<IPageOption>`
  background: ${({ isSelected }) => (isSelected ? "#dd6435" : "#ffffff")};
  border-color: ${({ isSelected }) => (isSelected ? "#dd6435" : "#dddddd")};

  a,
  p {
    color: ${({ isSelected }) => (isSelected ? "#ffffff" : "#666666")};
  }
`;